// Cookie consent for audience measurement (Google Analytics), following CNIL rules:
// nothing is loaded before an explicit "accept", refusing is as easy as accepting,
// and the choice expires after 13 months. Technical storage (session, language,
// this choice itself) does not need consent.
const STORAGE_KEY = "flowgantt_cookie_consent";
const MAX_AGE_MS = 395 * 24 * 60 * 60 * 1000; // 13 months
const GA_ID = "G-2G78GH48FG";

export const CONSENT_CHANGE_EVENT = "flowgantt:consent-change";
export const COOKIE_SETTINGS_EVENT = "flowgantt:cookie-settings";

// "granted" | "denied" | null (not asked yet, or choice expired)
export function getConsent() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { value, at } = JSON.parse(raw);
    if (value !== "granted" && value !== "denied") return null;
    if (!at || Date.now() - new Date(at).getTime() > MAX_AGE_MS) return null;
    return value;
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, at: new Date().toISOString() }));
  } catch {
    // Private mode: the choice applies to this page view only.
  }
  if (value === "granted") {
    loadAnalytics();
  } else {
    revokeAnalytics();
  }
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, { detail: value }));
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
}

let loaded = false;

function loadAnalytics() {
  window[`ga-disable-${GA_ID}`] = false;
  if (loaded) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

function revokeAnalytics() {
  // Stops any further hit from an already loaded tag, then drops its cookies.
  window[`ga-disable-${GA_ID}`] = true;
  const domains = ["", window.location.hostname, `.${window.location.hostname.replace(/^www\./, "")}`];
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0].trim();
    if (name === "_ga" || name.startsWith("_ga_") || name === "_gid") {
      domains.forEach((d) => {
        document.cookie = `${name}=; Max-Age=0; path=/${d ? `; domain=${d}` : ""}`;
      });
    }
  });
}

// Called once at startup: resumes measurement only if the visitor already accepted.
export function initAnalytics() {
  if (getConsent() === "granted") loadAnalytics();
}
